import { TextArea } from '@pay-com/components'
import {
  Controller,
  FieldPath,
  FieldValues,
  useFormContext
} from 'react-hook-form'
import { ChangeEvent } from 'react'
import { getErrorMessage } from 'utils/get-error-message'
import { useTranslation } from 'react-i18next'

interface ControlledTextareaProps<T extends FieldValues> {
  name: FieldPath<T>
  label?: string
  placeholder?: string
  disabled?: boolean
  isLoading?: boolean
  className?: string
}

export const ControlledTextarea = <T extends FieldValues>({
  name,
  label,
  placeholder,
  disabled,
  isLoading,
  className
}: ControlledTextareaProps<T>) => {
  const { control } = useFormContext<T>()
  const { t } = useTranslation('errors')

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { error } = fieldState

        return (
          <TextArea
            {...field}
            value={field.value ?? ''}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
              field.onChange(e.target.value)
            }}
            label={label}
            placeholder={placeholder}
            disabled={disabled || isLoading}
            error={Boolean(error)}
            errorMessage={getErrorMessage(t, error?.message)}
            className={className}
            size="medium"
            containerProps={{ style: { width: '100%' } }}
          />
        )
      }}
    />
  )
}
